'use strict';

var scroll;
var currentCheckXhr = null;

/**
 * Helper to add or remove classes using jQuery
 */
function addRemoveClass($el, action, className) {
    if (!$el || !$el.length || !action || !className) return;
    className.split(' ').forEach(function (c) {
        if (action === 'add') {
            $el.addClass(c);
        } else {
            $el.removeClass(c);
        }
    });
}

/**
 * Update the URL hash/history with the current AJAX url.
 */
function updateHash(currentUrl, options) {
    let url = new URL(currentUrl, window.location.origin);
    const paramKeys = Object.keys(options);

    for (let i = 0; i < paramKeys.length; i++) {
        url.searchParams.set(paramKeys[i], options[paramKeys[i]]);
    }

    window.history.pushState({}, '', url.search);
}

/**
 * Update DOM elements with Ajax results
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    var $targets = $(selector);

    if ($updates.length === 0) {
        $targets.addClass('d-none');
    } else {
        $targets.removeClass('d-none');
        $targets.each(function (index) {
            if ($updates[index]) {
              $(this).html($($updates[index]).html());
            }
        });
    }
}

/*
* When filters are applied, the buttons inside the filter sheet are updated.
*/
function updateFilterBtns() {

    var $activeSheet = $('.mm-sheet[id^="filters-"]');
    if (!$activeSheet.length) $activeSheet = $('#filters-sheet');

    var $applyBtn = $activeSheet.find('.apply-filters-button');
    var isMM6 = $activeSheet.data('brand') === 'mm6';
    var noFilter = true;

    if(isMM6) {
        noFilter = $('.filter-button-label .js-active-filters').hasClass('d-none');
    } else {
        // Check the sidebar checkboxes directly instead of the .active-filters pills bar:
        // that bar is only ever populated by appliedFiltersButtonDot(), which used to run
        // on every click back when every click applied immediately. With accumulate & apply
        // a filter can be selected on page load / after Apply without any click firing —
        // relying on the pills bar left the reset button stuck hidden in that case.
        noFilter = $activeSheet.find('.filters-sidebar-content input.js_refinement-link:checked').length === 0;
    }

    // CTA copy: "Apply filters" with nothing selected, "Apply" (+ results counter) otherwise
    var $primaryTxt = $applyBtn.find('.js-primary-txt');
    var $secondaryTxt = $applyBtn.find('.js-secondary-txt');
    if(noFilter) {
        $primaryTxt.text($primaryTxt.data('all-txt'));
        $secondaryTxt.addClass('d-none');
        $activeSheet.find('.js-filter-reset').addClass('d-none');
    } else {
        $primaryTxt.text($primaryTxt.data('view-txt'));
        $secondaryTxt.removeClass('d-none');
        $activeSheet.find('.js-filter-reset').removeClass('d-none');
    }
}

/**
 * Update dots on refinement button and accordion triggers
 * AND populate active filters pills + counter label
 */
function removeQueryParam(url, param) {
    try {
        var urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.delete(param);
        return urlObj.pathname + urlObj.search;
    } catch (e) {
        var reg = new RegExp('[?&]' + param + '=[^&]*', 'g');
        return url.replace(reg, '').replace(/^&/, '?');
    }
}

function appliedFiltersButtonDot() {
    var $activeSheet = $('.mm-sheet[id^="filters-"]');
    if (!$activeSheet.length) $activeSheet = $('#filters-sheet');

    var $categoryFilter = $('.category-menu-top-container');
    var $categoryFilterSelected = $('.mm-chip-wrapper .is-selected');
    var $filterSelected = $activeSheet.find('.filters-sidebar-content .js_container_elements_filters input:checked');

    var isMM6 = $activeSheet.data('brand') === 'mm6';
    var urlParams = new URLSearchParams(window.location.search);
    var isSortActive = !isMM6 && urlParams.has('srule');
    var $activeSortInput = $activeSheet.find('input[name="sort-order"]:checked');

    // For MM6 filter btn -- Logic to update number of active filters
    var $buttonCounterLabel = $('.filter-button-label .js-active-filters');
    if ($buttonCounterLabel.length) {
        //Clean the BTN
        $buttonCounterLabel.empty().addClass('d-none');
    }

    if ($filterSelected.length || isSortActive) {
        var $refinementsButton = $('.filter-button');
        var $activeFiltersDiv = $('.active-filters');
        var filterCount = 0;
        var isAlmostOneFilterSelected = false;

        // Reset dots in refinements sidebar
        $('.js-accordion-trigger').removeClass('-dot-info');

        // Clear active filters pills
        if ($activeFiltersDiv.length) {
            $activeFiltersDiv.empty();
        }

        $activeSheet.find('.filters-sidebar-content input:checked').each(function () {
            var $input = $(this);
            var linkedTitle = $input.data('link');
            var label = $input.next('label').text().trim() || $input.closest('li').text().trim();
            var dataHref = $input.data('href') || $input.closest('li').data('href');

            if (linkedTitle) {
                $('.mm-accordion-section.' + linkedTitle + ' .js-accordion-trigger').addClass('-dot-info');
                filterCount++;

                // Create pill
                if ($activeFiltersDiv.length) {
                    var pill = $('<button class="mm-button filter-selected mm-txt-capitals mm-content-primary">' + label + ' <i class="icon icon--mm-cross-small"></i></button>');
                    pill.find('i').after('<a href="' + dataHref + '" class="d-none"></a>');
                    $activeFiltersDiv.append(pill);
                }
            }
            isAlmostOneFilterSelected = true;
        });

        if (isSortActive) {
            var sortLabel = $activeSortInput.next('span').text().trim() || $activeSortInput.siblings('.mm6-radio__label').text().trim() || $activeSortInput.parent().text().trim();
            var resetSortHref = '';
            var sortHref = $activeSortInput.data('href') || $activeSortInput.val();
            if (sortHref) {
                resetSortHref = removeQueryParam(sortHref, 'srule');
                resetSortHref = removeQueryParam(resetSortHref, 'start');
            }

            if (resetSortHref) {
                filterCount++;
                if ($activeFiltersDiv.length) {
                    var pill = $('<button class="mm-button filter-selected mm-txt-capitals mm-content-primary">' + sortLabel + ' <i class="icon icon--mm-cross-small"></i></button>');
                    pill.find('i').after('<a href="' + resetSortHref + '" class="d-none"></a>');
                    $activeFiltersDiv.append(pill);
                }
                isAlmostOneFilterSelected = true;
            }
        }

        addRemoveClass($refinementsButton, isAlmostOneFilterSelected ? 'add' : 'remove', '-dot-info');

        // Toggle grid-top-filter based on active filters
        var $gridTopFilter = $('.grid-top-filter, .category-menu-top-container');
        if (isAlmostOneFilterSelected) {
            $gridTopFilter.addClass('d-none');
        } else {
            $gridTopFilter.removeClass('d-none');
        }

        // Update the BTN number
        if ($buttonCounterLabel.length) {
            if (filterCount > 0) {
                $buttonCounterLabel.text('(' + filterCount + ')').removeClass('d-none');
            }
        }

        // Update CSS variable for filter count indicator
        document.documentElement.style.setProperty('--content-filters', '"' + filterCount.toString() + '"');
    } else {
        $categoryFilter.removeClass('d-none');

        // Reset del counter se siamo in modalità quick filter senza filtri sidebar
        if ($buttonCounterLabel.length) {
            $buttonCounterLabel.empty().addClass('d-none');
        }

        $('.active-filters').remove();
    }

    collapseOverflowChips();
    checkFiltersBarOverflow();
}

/**
 * Desktop only, while .top-container lays the title and filter bar out side by side
 * (checked via computed flex-direction rather than a hardcoded viewport width, so this
 * stays in sync with whichever breakpoint tier currently enables that row layout — see
 * _searchresult.lg-min.scss): if the category nav's chips no longer fit their own
 * container (i.e. it would need its internal scroll to show them all), drop the whole
 * filter bar onto its own full-width row below the title instead — see
 * .top-container.is-filters-overflow in _searchresult.lg-min.scss. Mirrors
 * collapseOverflowChips' scrollWidth vs clientWidth check, but on the category nav rather
 * than the active-filters pills.
 */
function checkFiltersBarOverflow() {
    var $topContainer = $('.top-container');
    var $navContainer = $('.category-menu-top-container');
    var $chipWrapper = $navContainer.find('.mm-chip-wrapper');

    if (!$topContainer.length || !$navContainer.length || !$chipWrapper.length) return;

    // Always measure from the constrained (66.67vw-capped) state, regardless of whichever
    // state the class left things in: .category-menu-top-container's own clientWidth depends
    // on is-filters-overflow (that class releases the 66.67vw cap to 100%), so measuring while
    // it's still applied compares against a moving target — the bar widens, appears to fit,
    // the class gets removed, it narrows back, no longer fits, the class gets re-added... an
    // infinite flap right at the threshold width. Stripping it first forces every check to
    // start from the same baseline before deciding.
    $topContainer.removeClass('is-filters-overflow');

    var isRowLayout = $topContainer.css('flex-direction') === 'row';
    var isNavVisible = !$navContainer.hasClass('d-none') && $navContainer[0].offsetParent !== null;
    var isOverflowing = isRowLayout && isNavVisible && $chipWrapper[0].scrollWidth > $navContainer[0].clientWidth;

    $topContainer.toggleClass('is-filters-overflow', isOverflowing);
}

/**
 * Triggers the .filter-selected entrance transition (see _searchresult.default.scss) on
 * freshly-inserted chips. A double rAF guarantees the browser commits the opacity:0 paint
 * before the class flip, otherwise the transition can get coalesced into the same frame as
 * the insert and just appear instantly.
 */
function revealChips($chips) {
    if (!$chips || !$chips.length) return;
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            $chips.addClass('-show');
        });
    });
}

/**
 * Desktop only: collapse the active-filter chips that do not fit the bar width
 * into a leading "+N" counter chip (mobile keeps the horizontal scroll).
 * The latest selections stay visible; clicking the counter opens the filters
 * sheet so the user can review and change the full selection.
 */
function collapseOverflowChips() {
    var $bar = $('.active-filters');
    if (!$bar.length) return;

    // Reset the previous collapse state before measuring
    $bar.find('.js-chips-overflow').remove();
    var $pills = $bar.find('.filter-selected').removeClass('d-none');

    // Every chip here is either brand new (appliedFiltersButtonDot rebuilds the whole bar
    // on each update) or was just un-hidden above — reveal regardless of which overflow
    // branch runs below, since the early returns below don't touch this set.
    revealChips($pills);

    if (window.innerWidth < 768 || !$pills.length) return;
    if ($bar[0].scrollWidth <= $bar[0].clientWidth) return;

    // Placeholder text reserves a realistic width for the measurement pass
    var $counter = $('<button type="button" class="mm-button filter-selected mm-txt-capitals mm-content-primary chips-overflow js-chips-overflow">+99</button>');
    $bar.prepend($counter);
    revealChips($counter);

    var gap = parseFloat(window.getComputedStyle($bar[0]).columnGap) || 0;
    var available = $bar[0].clientWidth;
    var used = $counter.outerWidth();
    var hiddenCount = 0;
    var fitting = true;

    // Fill from the right so the most recent chips stay visible; once one no
    // longer fits, everything to its left collapses into the counter
    for (var i = $pills.length - 1; i >= 0; i--) {
        if (fitting) {
            var pillWidth = $($pills[i]).outerWidth() + gap;
            if (used + pillWidth <= available) {
                used += pillWidth;
                continue;
            }
            fitting = false;
        }
        $($pills[i]).addClass('d-none');
        hiddenCount++;
    }

    if (!hiddenCount) {
        $counter.remove();
        return;
    }
    $counter.text('+' + hiddenCount);
}

/**
 * Auto-scroll the cross category nav so the selected chip is fully visible.
 * Mobile centers it; desktop only nudges enough to uncover it (the bar is
 * right-aligned there, so its resting scrollLeft cuts the last chip off).
 */
function scrollToSelectedCrossCategoryNav() {
    var isMobile = window.innerWidth < 768;

    // The overflow container differs per breakpoint: the whole bar scrolls on mobile,
    // only .mm-chip-wrapper does on desktop (see _searchresult.md-min.scss).
    var $container = isMobile
        ? $('.filter-bar-revamp-inner')
        : $('.filter-bar-revamp-inner').find('.mm-chip-wrapper, .category-menu-top-container')
            .filter(function () { return this.scrollWidth > this.clientWidth; }).last();
    var $selected = $container.find('.mm-chip.is-selected');
    if (!$selected.length || !$container.length) return;

    var el = $selected[0];
    var container = $container[0];
    var target;

    if (isMobile) {
        target = el.offsetLeft - ($container.width() / 2) + ($selected.outerWidth() / 2);
    } else {
        // Rect-based: the chip's offsetParent is not the scroller on desktop.
        var left = el.getBoundingClientRect().left - container.getBoundingClientRect().left + container.scrollLeft;
        var right = left + el.offsetWidth;
        if (right > container.scrollLeft + container.clientWidth) {
            target = right - container.clientWidth;
        } else if (left < container.scrollLeft) {
            target = left;
        } else {
            return; // already fully visible
        }
    }

    setTimeout(function() {
        $container.animate({ scrollLeft: target }, 300);
    }, 100);
}

/**
 * DOM id for a refinement value <li>, mirroring boolean.isml's own id logic
 * (white swatches get a dedicated id for the hand-crafted CSS override).
 */
function buildRefinementValueId(value) {
    var slug = (value.idSelector || '').toLowerCase();
    if (slug !== 'multicolor' && value.hexColor && value.hexColor[0] === '#FFFFFF') {
        return 'filter-white';
    }
    return 'filter-' + value.idSelector;
}

/**
 * Builds a refinement value <li>, matching _search/refinements/attributes/boolean.isml,
 * for a value the server returned that isn't in the DOM yet (never rendered because it was
 * neither selectable nor selected at the last full render). Built with jQuery/DOM setters
 * only (.attr/.text/.css) — never string-concatenated HTML — since displayValue/title come
 * from catalog data and must not be treated as trusted markup.
 */
function buildRefinementValueMarkup(value, refinement) {
    var $li = $('<li class="value js_value"><span class="selection-box">'
        + '<input type="checkbox" class="js_refinement-link filter-option-input" />'
        + '<label class="filter-option-label mm-content-primary"></label>'
        + '</span></li>');

    $li.attr('id', buildRefinementValueId(value));
    $li.attr('data-value-id', value.idSelector);
    if (value.id) $li.addClass(value.id);
    if (value.title) $li.attr('title', value.title);

    var checkboxId = 'filter-checkbox-' + value.idSelector;
    $li.find('input').attr('id', checkboxId);
    $li.find('label').attr('for', checkboxId).text(value.displayValue);

    if (refinement.attributeID === 'macroColor' && value.hexColor && value.hexColor.length) {
        var $colorBox = $('<div class="color-box"><div class="single-color-box mm-color-swatch -md"></div></div>');
        $colorBox.find('.single-color-box').css('background-color', value.hexColor[0]);
        $li.find('label').before($colorBox);
    }

    return $li;
}

/**
 * Accumulate & apply — PHASE 1 (check filters).
 * Applies the JSON returned by Search-UpdateRefinementUrl to the filters sheet:
 * updates the Apply button (count + data-href with the ajaxPermalink), disables the
 * refinement values that are no longer selectable with the accumulated combination,
 * refreshes each value's urls and the per-group counters. The grid is NOT touched.
 */
function applyCheckResponse(response, $sheet) {
    if (!response) return;

    if (response.searchRedirect) {
        window.location.assign(response.searchRedirect);
        return;
    }

    var isMM6 = $sheet.data('brand') === 'mm6';
    var $sidebar = $sheet.find('.filters-sidebar-content');
    var $applyBtn = $sheet.find('.apply-filters-button');

    // Apply button: save the permalink for PHASE 2 and show the resulting count. A staged combo
    // that resolves to 0 is handled server-side (Search-ShowAjax auto-resets to the unfiltered
    // page), so the permalink is written unconditionally — no client-side 0-result guard.
    $applyBtn.attr('data-href', response.ajaxPermalink || '');
    $applyBtn.find('.js-filter-results').text(response.count);

    // Disable everything, then re-enable only what is still selectable
    $sidebar.find('li.js_value').addClass('filter-disabled');

    (response.cachedRefinements || []).forEach(function (refinement) {
        var $section = $sidebar.find('.js-accordion-section[data-attribute-id="' + refinement.attributeID + '"]');
        if (!$section.length) return;

        var $triggerLabel = $section.find('.js-accordion-trigger span').first();
        if ($triggerLabel.length) {
            var counterTxt = '';
            if (refinement.numSelected) {
                counterTxt = isMM6 ? ' (' + refinement.numSelected + ')' : ' [' + refinement.numSelected + ']';
            }
            $triggerLabel.text(refinement.displayName + counterTxt);
        }

        (refinement.values || []).forEach(function (value) {
            var $item = $section.find('li.js_value[data-value-id="' + value.idSelector + '"]');

            if (!$item.length) {
                // Server returned a value with no matching <li>: build it instead of
                // silently dropping the update. Every value the response mentions must end
                // up shown (dimmed via filter-disabled when relevant) — never missing.
                var $list = $section.find('.values').first();
                if (!$list.length) return;
                $item = buildRefinementValueMarkup(value, refinement);
                $list.append($item);
            }

            var $input = $item.find('input.js_refinement-link');
            if (value.url && value.url !== '#') $input.attr('data-href', value.url);
            if (value.checkUrl && value.checkUrl !== '#') $input.attr('data-filter-url', value.checkUrl);
            $input.prop('checked', !!value.selected);
            $item.toggleClass('selected-box', !!value.selected);
            // A value is clickable when selectable, OR already selected: the server always
            // returns a valid relax url for a selected value regardless of its selectable
            // flag (0 hits under the current combo is not a reason to block deselecting it).
            $item.toggleClass('filter-disabled', !(value.selectable || value.selected));
        });
    });

    // Sort urls must carry the accumulated refinements
    (response.sortOptions || []).forEach(function (option) {
        $sheet.find('input[name="sort-order"][value="' + option.id + '"]').attr('data-href', option.url);
    });

    var anySelected = (response.selectedFiltersCount || 0) > 0 || $sidebar.find('input.js_refinement-link:checked').length > 0;
    var $resetBtn = $sheet.find('.js-filter-reset');
    $resetBtn.toggleClass('d-none', !anySelected);
    if (response.resetAjaxLink) $resetBtn.attr('data-href', response.resetAjaxLink);

    // CTA copy: "Apply filters" with nothing selected, "Apply" (+ results counter) otherwise
    var $primary = $applyBtn.find('.js-primary-txt');
    var $secondary = $applyBtn.find('.js-secondary-txt');
    if (anySelected) {
        $primary.text($primary.data('view-txt'));
        $secondary.removeClass('d-none');
    } else {
        $primary.text($primary.data('all-txt'));
        $secondary.addClass('d-none');
    }
}

/**
 * Fires the lightweight JSON check against Search-UpdateRefinementUrl.
 * Aborts any in-flight check so only the latest selection wins.
 */
function checkRefinements(url, $sheet) {
    if (!url || url === '#') return;

    if (currentCheckXhr && currentCheckXhr.readyState !== 4) {
        currentCheckXhr.abort();
    }

    $sheet.addClass('is-checking-filters');
    currentCheckXhr = $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            applyCheckResponse(response, $sheet);
        },
        complete: function () {
            $sheet.removeClass('is-checking-filters');
        }
    });
}

/**
 * AJAX Result Parsing and DOM Update
 */
function parseResults(response, filterSheetId) {
    var $results = $(response);

    var baseSelectors = [
        '.refinement-bar',
        '.js-mobile-sort',
        '.refinements-categories',
        '.top-container',
        '.plp-top-editorial',
        '.mm-block-left-outside',
        '.mm-seo',
        '.mm-cross-category-wrapper',
        '.grid-product'
    ];

    // Capture open accordions state
    var openAccordions = [];
    $(filterSheetId).find('.js-accordion-section.is-active').each(function() {
        var attributeId = $(this).data('attribute-id');
        openAccordions.push(attributeId);
    });

    var $newSidebarContent = $results.find('.filters-sidebar-content');
    if ($newSidebarContent.length) {
        var $existingSidebar = $(filterSheetId).find('.filters-sidebar-content');
        if ($existingSidebar.length) {
            $existingSidebar.empty().html($newSidebarContent.html());

            // Restore open accordions
            openAccordions.forEach(function(attributeId) {
                var $section = $existingSidebar.find('.js-accordion-section[data-attribute-id="' + attributeId + '"]');
                if ($section.length) {
                    $section.addClass('is-active is-visible');
                    $section.find('.js-accordion-trigger').attr('aria-expanded', 'true');
                }
            });

            if (scroll !== undefined) {
                $existingSidebar[0].scrollTop = scroll;
            }
        }
    }

    baseSelectors.forEach(function (selector) {
        updateDom($results, selector);
    });

    // Shared hook so both brands are covered: MM renders breadcrumbs twice (header + page
    // header), MM6 only in the page header. The fragment always carries a single copy, so
    // updateDom's index pairing is not usable here.
    var $newBreadcrumbs = $results.find('.js-breadcrumbs-wrapper');
    if ($newBreadcrumbs.length) {
        $('.js-breadcrumbs-wrapper').html($newBreadcrumbs.first().html());
    }

    updateFilterBtns();
    scrollToSelectedCrossCategoryNav();

    // Permalink for history.pushState: #submit-url (or legacy input.permalink) from the AJAX response
    var $submitUrl = $results.filter('#submit-url').add($results.find('#submit-url'));
    if (!$submitUrl.length) {
        $submitUrl = $results.filter('input.permalink').add($results.find('input.permalink'));
    }

    return {
        permalink: $submitUrl.length ? $submitUrl.first().val() : null
    };
}

/**
 * Push a history entry for a grid state we can restore later.
 * The state carries the Search-ShowAjax url so popstate can re-fetch the same grid.
 *
 * @param {string} ajaxUrl Search-ShowAjax url that produced the current grid
 * @param {string} shownUrl url to display in the address bar
 * @param {boolean} replace replace the current entry instead of pushing a new one
 */
function pushGridState(ajaxUrl, shownUrl, replace) {
    // plpGrid marks the entry as ours; a null plpAjaxUrl means "server-rendered
    // entry, restore it with a reload" (see the popstate handler).
    var state = { plpGrid: true, plpAjaxUrl: ajaxUrl };

    // Re-selecting the view already on screen must not stack a duplicate entry,
    // or "back" looks broken (it consumes a click without visibly moving). 
    var current = window.location.pathname + window.location.search;
    var target = new URL(shownUrl, window.location.origin);
    if (!replace && target.pathname + target.search === current) return;

    if (replace) {
        window.history.replaceState(state, '', shownUrl);
    } else {
        window.history.pushState(state, '', shownUrl);
    }
}

/**
 * AJAX Apply Filters
 */
function ajaxApplyFilter(url, filterSheetId, updateNewURL, skipHistory) {
    var $sidebar = $(filterSheetId).find('.filters-sidebar-content');
    var isSheetOpen = $(filterSheetId).is(':visible');

    if ($sidebar.length > 0) scroll = $sidebar[0].scrollTop;

    $.ajax({
        url: url,
        data: {
            page: $('.grid-footer').data('page-number') || 1,
            selectedUrl: url,
        },
        method: 'GET',
        success: function (response) {
            // A removal that lands on a 0-product combo is resolved server-side: Search-ShowAjax
            // auto-resets to the unfiltered page, so the response always carries a real grid here.
            var parsed = parseResults(response, filterSheetId);

            // Swap is done: whatever loading state was applied before the request (apply
            // button or load-more), it's safe to clear here regardless of which one fired.
            $('.grid-product').removeClass('is-grid-loading');

            // OTB26-2354: Every grid change pushes its own entry, tagged with the ajax url 
            // so popstate can replay it. 
            // skipHistory is set when we are replaying: the browser already moved the entry.
            if (!skipHistory) {
              if (updateNewURL) {
                var shownUrl = updateNewURL;
                try {
                  var newURL = new URL(updateNewURL, window.location.origin);
                  shownUrl = newURL.pathname + newURL.search;
                } catch (e) {
                  shownUrl = updateNewURL;
                }
                pushGridState(url, shownUrl);
              } else if (parsed && parsed.permalink) {
                pushGridState(url, parsed.permalink);
              } else {
                updateHash(url, { lastAction: 'applyFilter' });
              }
            }

            $('body').trigger('product:update-plp-cards');

            $.event.trigger({
                type: 'appliedFilter',
                url: url,
            });

            // Maintain body scroll lock if sheet is still open
            if (isSheetOpen) {
                $('body').addClass('no-overflow');
            }

            // Analytics Tracking
            var names = [];
            var skus = [];
            $('.product-grid-container .product').each(function () {
                if (this.dataset.productName) names.push(this.dataset.productName);
                if (this.dataset.pid) skus.push(this.dataset.pid);
            });

            if (window.SubCategoryList_track) {
                window.SubCategoryList_track({
                    page_category: $('.category-menu-top-categories-category.selected').length ? $('.category-menu-top-categories-category.selected')[0].id : '',
                    product_impression_sku: skus,
                    product_impression_name: names
                });
            }
        },
        error: function () {
            // Grid never got replaced: don't leave it stuck at opacity 0
            $('.grid-product').removeClass('is-grid-loading');
        }
    });
}

/**
 * AJAX Load More logic
 */
function ajaxShowMore(showMoreUrl, callback) {
    $.ajax({
        url: showMoreUrl,
        data: { selectedUrl: showMoreUrl },
        method: 'GET',
        success: function (response) {
          $('.js_grid-footer').replaceWith(response);

          var newStart = new URL(showMoreUrl, window.location.origin).searchParams.get('start');
          updateHash(showMoreUrl, {
              lastAction: 'showMore',
              untilStart: newStart,
          });

          if (callback) callback();
        },
        error: function () {
          if (callback) callback();
        }
    });
}

/**
 * UI Refresh Helpers
 */

function getCustomerWishlist() {
    var $wishlistBtn = $('.js-header-wishlist');
    var url = $wishlistBtn.length ? $wishlistBtn.data('customer-wishlist-products') : null;
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function (responseData) {
                if (responseData && responseData.wishlistIDS) {
                    $('.js_add-to-wish-list').removeClass('active');
                    responseData.wishlistIDS.forEach(function (item) {
                        $('.js_add-to-wish-list[data-pid="' + item + '"]').addClass('active');
                    });
                }
            }
        });
    }
}

function initFilterBarScroll() {
    var $bar = $('.top-container .filter-bar-revamp-inner');
    var $btn = $bar.find('.filter-button');
    var $label = $btn.next('.filter-button-label');

    if (!$bar.length || !$btn.length || !$label.length) return;

    // The label is a plain sibling, so the browser scrolls it away natively behind the
    // sticky button (see filterBar_mm.isml). Nothing to move here: only fade the
    // separator in once the label is fully hidden under the button.
    function onFilterBarScroll() {
        var label = $label[0].getBoundingClientRect();
        var hidden = label.width > 0 && label.right <= $btn[0].getBoundingClientRect().right;
        $btn.toggleClass('-collapsed', hidden);
    }

    // init runs again after every filter update — rebind, don't stack handlers
    $bar.off('scroll.filterbar').on('scroll.filterbar', onFilterBarScroll);
    onFilterBarScroll();
}

//OTB26-652 - NOT in Scope
function initScalingGrid() {

    $(document).on('click', '.js-grid-zoom-in, .js-grid-zoom-out', function(e) {
        e.preventDefault();

        const $btn = $(this);
        const $gridParent = $('.product-grid');
        const $buttonParent = $('.js-scale-controls');
        const $gridContainer = $('.js-product-grid-container');

        if (!$gridParent.length || !$gridContainer.length) return;

        const sizes = ['small', 'default', 'large'];

        // Recuperiamo lo stato corrente leggendolo direttamente dall'attributo del padre
        let currentSize = $gridParent.attr('data-current-grid') || 'default';
        let currentIndex = sizes.indexOf(currentSize);

        // Capiamo quale bottone è stato cliccato
        if ($btn.hasClass('js-grid-zoom-in')) {
            // Click su "+" -> Rende le tile più grandi (va verso large)
            if (currentIndex < sizes.length - 1) {
                currentIndex++;
            }
        } else if ($btn.hasClass('js-grid-zoom-out')) {
            // Click su "—" -> Rende le tile più piccole (va verso small)
            if (currentIndex > 0) {
                currentIndex--;
            }
        }

        const newSize = sizes[currentIndex];

        // 1. Aggiorna le classi sul container della griglia
        $gridContainer.removeClass('is-grid-small is-grid-default is-grid-large')
            .addClass(`is-grid-${newSize}`);

        // 2. Aggiorna l'attributo di stato sul padre
        $gridParent.attr('data-current-grid', newSize);

        // 3. Aggiorna lo stato dei bottoni (disabled e aria-disabled)
        updateButtonsState($buttonParent, currentIndex, sizes.length);
    });

    // Funzione helper interna per gestire gli attributi dei bottoni
    function updateButtonsState($parent, index, totalSizes) {
        const $btnMin = $parent.find('.js-grid-zoom-out');
        const $btnMax = $parent.find('.js-grid-zoom-in');

        const isSmallest = (index === 0);
        const isLargest = (index === totalSizes - 1);

        // Gestione Bottone "—"
        $btnMin.prop('disabled', isSmallest)
            .attr('aria-disabled', isSmallest ? 'true' : 'false');

        // Gestione Bottone "+"
        $btnMax.prop('disabled', isLargest)
            .attr('aria-disabled', isLargest ? 'true' : 'false');
    }

    // Inizializzazione al caricamento (o dopo che il DOM è pronto)
    // Se la griglia viene aggiornata via AJAX, ricordati di rieseguire solo questo blocco di init
    $(function() {
        const $gridParent = $('.product-grid');
        if ($gridParent.length) {
            const sizes = ['small', 'default', 'large'];
            const currentSize = $gridParent.attr('data-current-grid') || 'default';
            const currentIndex = sizes.indexOf(currentSize);

            // Applica lo stato iniziale e imposta i bottoni di conseguenza
            $('.js-product-grid-container').addClass(`is-grid-${currentSize}`);
            updateButtonsState($gridParent, currentIndex, sizes.length);
        }
    });
}

/**
 * Calcola e aggiorna il numero totale dei prodotti visibili
 */
function updateProductCount() {
    var $hits = $('.js_you-have-seen');
    var totalElements = $hits.length > 0 ? $hits.data('productcount') : $('.product-grid-container .js_tile').length;

    if (document.getElementById('plp-result-number')) {
        document.getElementById('plp-result-number').innerText = totalElements;
    }
    if (document.querySelector('.results-label')) {
        document.querySelector('.results-label').innerText = totalElements;
    }

    var $activeSheet = $('.mm-sheet[id^="filters-"]');
    if (!$activeSheet.length) $activeSheet = $('#filters-sheet'); // Fallback

    var $applyBtn = $activeSheet.find('.apply-filters-button');
    if ($applyBtn.length && totalElements !== undefined) {

        var $btnCounter = $applyBtn.find('.js-filter-results');

        if ($btnCounter.length) {
            $btnCounter.text(totalElements);
        }
    }
}

module.exports = {
    init: function () {
        // Initial setup
        appliedFiltersButtonDot();
        getCustomerWishlist();
        initFilterBarScroll();
        updateProductCount();
        updateFilterBtns();
        scrollToSelectedCrossCategoryNav();

        // OTB26-2354: tag the entry the PLP was loaded on, so going back to it
        // from a chip/spotlight/filter entry is handled instead of ignored.
        //
        // No ajax url is stored: the page was rendered by the server and there is
        // no reliable way to rebuild its Search-ShowAjax equivalent — on a SEO
        // path (/it_IT/maison-margiela/donna/borse/) neither the address bar nor
        // input.permalink carries a cgid. The popstate handler reloads instead,
        // which reproduces that view exactly, on SEO paths and Search-Show alike.
        //
        // Outside a search page there is no grid and nothing is tagged: other
        // components (MMAccountTabs, MMHelpDashboard) keep owning their popstate,
        // and untagged entries are ignored by the handler below.
        if ($('.grid-product').length) {
            pushGridState(null, window.location.href, true);
        }
        window.addEventListener('popstate', function (e) {
            if (!e.state || !e.state.plpGrid) return;

            // The entry the page was served on has no ajax url: only a reload
            // reproduces it. It is the last step out of the ajax flow, so the
            // cost lands once, where the user is leaving the grid anyway.
            if (!e.state.plpAjaxUrl) {
                window.location.reload();
                return;
            }

            $('.grid-product').addClass('is-grid-loading');
            ajaxApplyFilter(e.state.plpAjaxUrl, '#filters-sheet', null, true);
        });

        // Listeners
        $('body').on('product:update-plp-cards', function () {
            appliedFiltersButtonDot();
            initFilterBarScroll();
            updateProductCount();
        });

        // Re-evaluate the chips overflow counter when the viewport changes
        var chipsResizeTimer;
        $(window).on('resize', function () {
            clearTimeout(chipsResizeTimer);
            chipsResizeTimer = setTimeout(function () {
                collapseOverflowChips();
                checkFiltersBarOverflow();
            }, 150);
        });

        // Load more handler
        $('body').on('click', '.js_button-load-more', function (e) {
          e.preventDefault();
          var $btn = $(this);
          if ($btn.hasClass('is-loading')) return;

          var url = $btn.data('url');
          if (!url) return;

          var $label = $btn.find('.js-loadmore-label');
          var defaultLabel = $label.text();

          // CTA in stato loading: label "Loading…", non cliccabile
          $btn.addClass('is-loading').attr('aria-busy', 'true');
          if ($btn.data('loading-label')) $label.text($btn.data('loading-label'));

          // Full loader: tutte le card tornano allo stato skeleton durante la richiesta
          $('.grid-product .js-product-grid-container').addClass('is-grid-loading');

          const firstGridContainer = document.querySelector('.grid-product .js-product-grid-container');
          ajaxShowMore(url, function () {
            document.querySelectorAll('.grid-product .js-product-grid-container').forEach( (grid, index) => {
              if(index !== 0) {
                grid.classList.remove('row');
                grid.classList.remove('product-grid-container');
                grid.classList.remove('js-product-grid-container');
                grid.classList.add('parent-to-be-removed');
                const parentContent = $(".parent-to-be-removed").contents();
                firstGridContainer.appendChild(grid);
                $(".parent-to-be-removed").replaceWith(parentContent);
              }
            });

            $('.grid-product .js-product-grid-container').removeClass('is-grid-loading');

            // Solo caso errore: su successo il footer viene rimpiazzato e la CTA arriva già resettata
            if ($btn.hasClass('is-loading')) {
              $btn.removeClass('is-loading').removeAttr('aria-busy');
              $label.text(defaultLabel);
            }

            $('body').trigger('product:listing-show-more');
            $('body').trigger('product:update-plp-cards');
          });

          getCustomerWishlist();
        });

        // Filter Apply logic
        $('body').on('click', '.js_refinement-link, .js_filter-remove, .js-filter-reset', function (e) {
          if ($(this).data('redirection-applied') !== true && !$(this).hasClass('is-selected')) {
            e.stopPropagation();

            var $this = $(this);

            // Accumulate & apply, MM only — PHASE 1: refinements inside the filters sheet only run
            // the lightweight JSON check; the grid updates on "Apply" (PHASE 2).
            // MM6 keeps the classic behavior: every click applies immediately.
            var $accumulateSheet = $this.closest('.mm-sheet');
            var isAccumulateSheet = $accumulateSheet.data('brand') !== 'mm6';

            if ($this.hasClass('js_refinement-link') && $this.closest('.filters-sidebar-content').length && isAccumulateSheet) {
              var checkUrl = $this.attr('data-filter-url') || ($this.attr('data-href') || '').replace('Search-ShowAjax', 'Search-UpdateRefinementUrl');
              checkRefinements(checkUrl, $accumulateSheet);
              return;
            }

            // Reset must clear the STAGED combination too, not just whatever's already
            // applied to the grid: uncheck every input in the sheet instantly instead of
            // waiting for the resetAjaxLink round-trip to swap the sidebar html back in.
            if ($this.hasClass('js-filter-reset') && isAccumulateSheet) {
              var $resetSidebar = $accumulateSheet.find('.filters-sidebar-content');
              $resetSidebar.find('input.js_refinement-link, input[name="sort-order"]').prop('checked', false);
              $resetSidebar.find('li.js_value').removeClass('selected-box filter-disabled');
              $resetSidebar.find('.js-accordion-trigger span').each(function () {
                var $span = $(this);
                $span.text($span.text().replace(/\s*[[(]\d+[\])]\s*$/, ''));
              });
              $accumulateSheet.find('.apply-filters-button').attr('data-href', '');
            }

            var url = $this.data('href') || $this.attr('href');
            if (!url) return;

            var updateNewURL = false;
            var $parentSheet = $this.closest('.mm-sheet');
            var filterSheetId = $parentSheet.attr('id') ? '#' + $parentSheet.attr('id') : '#filters-sheet'; // fallback

            if (e.currentTarget.classList.contains('category-menu-top-categories-category')) {
              if (e.currentTarget.dataset.alternativeUrl) {
                var alternativeUrl = e.currentTarget.dataset.alternativeUrl;
                var urlObj = new URL(alternativeUrl);
                var categoryID = urlObj.pathname;
                updateNewURL = categoryID;
              } else {
                updateNewURL = e.currentTarget.dataset.url;
              }
              if (window.isMobile()) {
                var selectedItem = $(this);

                selectedItem[0].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
              }

              $('.category-menu-top-categories').find('.selected').removeClass('selected');
            }

            // Trigger for custom tracking/logic
            $(this).trigger('search:filter', e);

            // Margiela revamp specific behavior: scroll only if not already selected
            // Only unlock body if the sheet is NOT open
            var isSheetOpen = $parentSheet.is(':visible');
            if (!isSheetOpen && !$this.hasClass('selected-box') && !$this.closest('.filter-option-input').prop('checked')) {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }

            $('.grid-product .js-product-grid-container').addClass('is-grid-loading');
            ajaxApplyFilter(url, filterSheetId, updateNewURL);
          }
        });

        // Sort Apply logic
        $('body').on('change', '[name=sort-order]', function (e) {
            e.stopPropagation();
            var $parentSheet = $(this).closest('.mm-sheet');
            var filterSheetId = $parentSheet.attr('id') ? '#' + $parentSheet.attr('id') : '#filters-sheet';

            var url = $(this).attr('data-href') || $(this).val();
            if (!url) return;

            // Accumulate & apply (MM only): inside the filters sheet the sort choice is staged too
            if ($(this).closest('.filters-sidebar-content').length && $parentSheet.data('brand') !== 'mm6') {
              checkRefinements(url.replace('Search-ShowAjax', 'Search-UpdateRefinementUrl'), $parentSheet);
              return;
            }

            $('.grid-product .js-product-grid-container').addClass('is-grid-loading');


            ajaxApplyFilter(url, filterSheetId);
        });

        // Accumulate & apply — PHASE 2: fetch the accumulated ajaxPermalink and swap the DOM.
        // Uses the same "full loader" class as load-more (.is-grid-loading, see
        // _product-card.default.scss / _product-card-mm6.default.scss) instead of stripping
        // swiper-lazy-loaded/lazyloaded directly on the tiles: closing the sheet re-triggers
        // swiper/lazyload on the still-in-DOM old grid before Search-ShowAjax responds, which
        // put the classes right back and skipped the fade. The CSS class forces opacity 0
        // with !important regardless of that churn, and disappears on its own once the grid
        // markup is fully replaced by the fresh response.
        $('body').on('click', '.apply-filters-button', function () {
            var $btn = $(this);
            var url = $btn.attr('data-href');
            if (!url) return; // nothing staged: the button only closes the sheet

            var $parentSheet = $btn.closest('.mm-sheet');
            var filterSheetId = $parentSheet.attr('id') ? '#' + $parentSheet.attr('id') : '#filters-sheet';

            // .grid-product itself is never touched by updateDom (only its innerHTML is),
            // unlike .js-product-grid-container, which gets destroyed and recreated by the
            // swap — a class added there is gone before the browser ever paints it, so the
            // old grid just sits fully visible for the whole request, then pops straight to
            // the new one. Adding it to the stable parent keeps it visible for the full wait.
            $('.grid-product').addClass('is-grid-loading');

            ajaxApplyFilter(url, filterSheetId);
            $btn.attr('data-href', '');
        });

        // Close modal/sheet handler
        $('body').on('click', '.js-sheet-close', function () {
            const sheeetId = $(this).data('option-target');
            document.dispatchEvent(new CustomEvent("MMSheet:close", {
                detail: { id: sheeetId }
            }));
        });

        // Filter selected pill click (deselection via active filters bar)
        $('body').on('click', '.filter-selected', function (e) {
            e.preventDefault();

            // "+N" overflow counter: opens the filters sheet instead of deselecting
            if ($(this).hasClass('js-chips-overflow')) {
                var overflowSheetId = $(this).closest('.active-filters').data('filters-sheet-id') || 'filters-sheet';
                document.dispatchEvent(new CustomEvent('MMSheet:open', { detail: { id: overflowSheetId } }));
                return;
            }

            var url = $(this).find('a').attr('href');

            var $parentSheet = $(this).parents('active-filters');
            var filterSheetId = $parentSheet.attr('filters-sheet-id') ? '#' + $parentSheet.attr('filters-sheet-id') : '#filters-sheet';

            if (url) {
                $('.grid-product .js-product-grid-container').addClass('is-grid-loading');

                ajaxApplyFilter(url, filterSheetId);
            } else {
                var target = $(this).text().trim().replace(/\s+/g, '-').toLowerCase();
                // Cerca il filtro dentro lo sheet corrente (Margiela o MM6)
                var $activeSheet = $('.mm-sheet[id^="filter-"]');
                var $filter = $activeSheet.find('#filter-' + target);
                if ($filter.length) $filter.click();
            }
        });

        // Scroll history handling
        $('body').on('click', '.js-product-grid-container li .product', function () {
            sessionStorage.setItem('plpScrollPosition', $(window).scrollTop());
            sessionStorage.setItem('plpScrollValid', 'true');
        });

        $(window).on('pageshow', function () {
            if (!document.querySelector('.js-product-grid-container')) return;

            var navType = 'navigate';
            if (window.performance && window.performance.getEntriesByType) {
                var navEntries = performance.getEntriesByType('navigation');
                if (navEntries.length > 0) navType = navEntries[0].type;
            }
            var scrollY = sessionStorage.getItem('plpScrollPosition');
            var isValid = sessionStorage.getItem('plpScrollValid') === 'true';
            if (navType === 'back_forward' && scrollY !== null && isValid) {
                setTimeout(() => window.scrollTo(0, parseInt(scrollY, 10)), 100);
            }
            sessionStorage.removeItem('plpScrollPosition');
            sessionStorage.removeItem('plpScrollValid');
        });
    }

};
